import { createStateSelectorHook } from 'src/lib/sweetState';
import { ProjectStore } from 'src/store/project';

const useProjectState = createStateSelectorHook(ProjectStore, ['selectedImageStyleId']);

export const useViewState = () => {
  const { selectedImageStyleId } = useProjectState();

  return {
    selectedImageStyleId,
  };
};
